var _path, _path2, _path3;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ELearning = function ELearning(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: [_path || (_path = /*#__PURE__*/_jsx("path", {
      fill: "none",
      className: "tw-fill-current",
      d: "M16.698 18.294H7.21c-.93 0-1.675-.744-1.675-1.675V9.178h12.837v7.441c0 .93-.744 1.675-1.674 1.675Z",
      opacity: 0.4
    })), _path2 || (_path2 = /*#__PURE__*/_jsx("path", {
      fill: "none",
      className: "tw-fill-current",
      d: "M3.674 15.968v-7.07c0-.278-.186-.464-.465-.464s-.465.186-.465.465v7.07c0 .278.186.464.465.464.28 0 .465-.186.465-.465Z"
    })), _path3 || (_path3 = /*#__PURE__*/_jsx("path", {
      fill: "none",
      className: "tw-fill-current",
      d: "M1.349 8.713 11.395 5.55a2.655 2.655 0 0 1 1.21 0L22.65 8.713c.465.186.465.651 0 .837l-10.046 3.163a2.653 2.653 0 0 1-1.21 0L1.35 9.55c-.465-.186-.465-.651 0-.837Z"
    }))]
  });
};
export default ELearning;